import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    company: state.components.contactUsForm.fieldValues["company"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CompanyStyles {
    companyTextField?: TextFieldPresentationProps;
}

export const companyStyles: CompanyStyles = {};

const styles = companyStyles;

const Company: React.FC<Props> = ({ fields, company, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [companyErrorMessage, setCompanyErrorMessage] = React.useState("");

    React.useEffect(() => {
        contactFormContext.validators.company = validateCompany;
        if (typeof company !== "undefined") {
            validateCompany();
        }
    }, [company]);

    React.useEffect(() => {
        contactFormContext.validators.company = validateCompany;
    }, [isRequired]);

    const validateCompany = () => {
        const errorMessage = isRequired && !company ? (siteMessage("Field_Required", label) as string) : "";
        setCompanyErrorMessage(errorMessage);
        return !errorMessage;
    };

    const companyChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "company", value: event.target.value });
    };

    return (
        <TextField
            {...styles.companyTextField}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={company || ""}
            error={companyErrorMessage}
            onChange={companyChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Company),
    definition: {
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Company",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Enter Company",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
